<template>
    <li class="dashboard-config-tab"
        :class="[selectedSection === section.section ? 'el--active' : '']"
        role="button"
        tabindex="0"
        @keydown.enter.prevent="$event.currentTarget.click()"
        @keydown.32.prevent="$event.currentTarget.click()">
        <StatusIndicator v-if="!isValid" :title="uiTitle" class="sm-r-s" />
        <span class="o-ol u-us-n u-pe-n tab-label">{{ section.section_label | athT }}</span>
        <ButtonIcon class="el--transparent el--s-s" icon="chevron-right" />
    </li>
</template>
<script>
import { isNeObject } from '@aretheyhappy/utils';
import ButtonIcon from '../../../atoms/ButtonIcon.vue';
import StatusIndicator from '../../../atoms/visuals/StatusIndicator.vue';
export default {
    components: {ButtonIcon, StatusIndicator},
    props: {
        /**
         * The configuration section this tab represents, including its section key,
         * label, and an isValid function used to validate the current config.
         */
        section: {type: Object, default: () => ({})},
        /**
         * The section key of the currently selected/active tab, used to highlight
         * this tab when it matches section.section.
         */
        selectedSection: {type: String, default: ''},
        /**
         * The current widget configuration, passed to section.isValid to determine
         * whether this tab's settings are complete/valid.
         */
        config: {type: Object, default: () => ({})}
    },
    computed: {
        validation: function () {
            return this.section.isValid(this.config);
        },
        isValid: function () {
            return isNeObject(this.validation) ? this.validation.isValid : true;
        },
        uiTitle: function () {
            return isNeObject(this.validation) ? this.validation.errorMessages : '';
        }
    }
}
</script>
<style lang="scss">
@import '../../../../../sass/variables';
.dashboard-config-tab {
     border: 1px solid transparent;
    border-radius: 0;
    padding: $s-s;
    cursor: pointer;
    min-height: 4rem;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    max-width: 100%;

    &:not(.el--active) {
        &:not(:first-of-type) {
            border-top-color: var(--c-panel-border);
        }

        &:hover {
            background-color: var(--c-brand-light-bg);
            color: var(--c-brand-light-fg);
            border-radius: $br-s;
        }
    }

    .tab-label {
        flex-grow: 1;
        font-size: $fs-m;
        font-family: $ff-h;
        text-overflow: ellipsis;
    }

    &.el--active {
        background-color: var(--c-panel-bg);
        border-radius: $br-s;
        box-shadow: 0 0 0 1px var(--c-panel-border-active), var(--c-shade-m);
        z-index: 1;

        & > .tab-label {
            font-weight: bold;
        }
    }
}
</style>